import React, { useEffect } from 'react';
import { CircleLoader } from '@/components/CircleLoader';
import { useTranslation } from 'react-i18next';
import { Text } from '@/components/Text';
import { Group } from '@/components/Group';
import { Offset } from '@/components/Offset';
import { tk } from '@/i18n/translationKeys';
import { Actions, Height } from '../../AddPaymentMethodPage.styles';
import { ScreenCommon } from '../../types';
import { useApplicationData } from '@/providers/applicationData';
import { useScreenMatch } from '@/hooks/useScreenMatch';
import { BrandSepaIcon } from '@/icons/BrandSepaIcon';
import { PaymentOptionType } from '@/generated/types';
import { useCreatePaymentMethod } from '../../useCreatePaymentMethod';
import { useTheme } from 'styled-components';

export const SepaRedirectionScreen = ({ setScreen, paymentOptions }: ScreenCommon) => {
  const { t } = useTranslation();
  const { userId } = useApplicationData();
  const { isMobile } = useScreenMatch();
  const [createPaymentMethod] = useCreatePaymentMethod();
  const theme = useTheme();
  useEffect(() => {
    createPaymentMethod({ option: PaymentOptionType.SEPA });
  }, [userId, paymentOptions, setScreen]);

  return (
    <Height units={68} mobile={isMobile}>
      <Offset top={36}>
        <Group centered vertical gap={8} mobileGap={8}>
          <CircleLoader />
          <Text centered typography="RegularParagraph" color={theme.colors.text.baseGrey}>
            {t(tk.sepaRedirectionText)}
          </Text>
        </Group>
      </Offset>

      <Actions mobile={isMobile}>
        <BrandSepaIcon width={64} />
      </Actions>
    </Height>
  );
};
